import * as React from 'react';

interface CenteredTextProps {
    className: string;
    maxHeight: string;
    horizontalAlign?: React.CSSProperties['textAlign'];
    verticalAlign?: string;
    text?: string;
}

export class CenteredText extends React.PureComponent<CenteredTextProps> {
    public render(): JSX.Element {
        const labelStyle: React.CSSProperties = {
            maxHeight: this.props.maxHeight,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: this.props.horizontalAlign ? this.props.horizontalAlign : 'center',
            whiteSpace: 'normal'
        };
        return (
            <div className={this.props.className} style={{display: 'table', height: this.props.maxHeight}}>
                <div style={{display: 'table-cell', verticalAlign: this.props.verticalAlign ? this.props.verticalAlign : 'middle'}}>
                    <div style={labelStyle}>{this.props.text ? this.props.text : this.props.children}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CenteredText.tsx